import React, { createContext, useContext, useEffect, useState } from 'react';
import LoadingComponent from '../components/loading/LoadingComponent';
import AuthServices from '../services/AuthServices';
import LoginExternalServices from '../services/loginexternalservices/LoginExternalServices';
import { UserDTO } from '../services/Dtos/UserDTO';
import logsUserService from '../services/LogsUserActionService';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [userInfo, setUserInfo] = useState(null);

    // useState for user information
    const [token, setToken] = useState(null);
    const [name, setName] = useState(null);
    const [lastName, setLastName] = useState(null);
    const [email, setEmail] = useState(null);
    const [idUser, setIdUser] = useState(null);
    const [source, setSource] = useState(null);

    // Effect to handle authentication and local storage
    useEffect(() => {

        const publicRoutes = ["/register-external-poep", ]; // Rutas que no requieren autenticación
        const currentPath = window.location.pathname;
    
        if (publicRoutes.includes(currentPath)) {
            setIsLoading(false);
            return;
        }

        console.log('Entro');

        const initializeAuth = async () => {
            const storedToken = sessionStorage.getItem('token');

            if (storedToken) {
                setToken(storedToken);
                setName(sessionStorage.getItem('name'));
                setLastName(sessionStorage.getItem('lastName'));
                setIdUser(sessionStorage.getItem('idUser'));
                setEmail(sessionStorage.getItem('email'));
                setSource(sessionStorage.getItem('source'));
                setIsLoading(false);
                return;
            }

            const urlParams = new URLSearchParams(window.location.search);
            const requiredParams = ['firstName', 'lastName', 'id', 'email'];
            const allParamsExist = requiredParams.every(param => urlParams.has(param));

            if (allParamsExist) {
                const newUserInfo = new UserDTO(
                    urlParams.get('id'),
                    urlParams.get('firstName'),
                    urlParams.get('lastName'),
                    urlParams.get('email'),
                    null
                );

                setUserInfo(newUserInfo);

                try {
                    const results = await AuthServices(newUserInfo.ciam_id, newUserInfo);
                    
                    if (results) {
                        sessionStorage.setItem('token', results['access']);
                        sessionStorage.setItem('name', results['name']);
                        sessionStorage.setItem('lastName', results['last_name']);
                        sessionStorage.setItem('idUser', results['id_user']);
                        sessionStorage.setItem('email', urlParams.get('email'))

                        setToken(results['access']);
                        setName(results['name']);
                        setLastName(results['last_name']);
                        setIdUser(results['id_user']);
                        setEmail(urlParams.get('email'));
                        setIsLoading(false);


                        await logsUserService(urlParams.get('id'), 'Login', results['access']);

                        // Clear URL parameters without reloading
                        const newUrl = window.location.origin + window.location.pathname;
                        window.history.replaceState({}, document.title, newUrl);
                    }
                } catch (error) {
                    console.error('Auth error:', error);
                    setIsLoading(false);
                }
            } else {
                window.location.href = 'https://www.onenovonordisk.com/';
            }
        };

        initializeAuth();
    }, []);

    const logout = () => {
        // setToken(null);
        // setName(null);
        // setLastName(null);
        // setIdUser(null);
        // setEmail(null);
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('name');
        sessionStorage.removeItem('lastName');
        sessionStorage.removeItem('idUser');
        sessionStorage.removeItem('email');
        sessionStorage.removeItem('source');
    };

    if (isLoading) {
        return <LoadingComponent text={'redirigiendo'} />;
    }

    return (
        <AuthContext.Provider value={{ token, name, lastName, email, idUser, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    return useContext(AuthContext);
};
